import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function regionalAirports(state=initialState.regionalAirports, action) {
  switch (action.type) {
    case appConstants.REGIONAL_AIRPORTS_SUCCESS:
      return action.regionalAirports;
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/_reducers/regional-airport-reducer.js